import classNames from "classnames"

export const LiveBadge = ({
    label = "Live",
    className,
}: {
    label?: string
    className?: string
}) => (
    <div className={classNames("px-1 rounded-md bg-red-500 shrink-0 text-white", className)}>
        {label}
    </div>
)
